import Styled from 'styled-components';

const Card = Styled.div`
    .ant-card{
        border-radius: 15px !important;
    }
    .ant-card .ant-card-body{        
        border-radius: 15px !important;
        color: ${({ theme }) => theme['gray-color']};    
        padding-bottom: 20px !important;
        padding-top: 20px !important;
        transition: .35s;
        h4{
            display: flex;
            align-items: center;
            font-size: 16px;
            margin-bottom: 16px;
            color: ${({ theme }) => theme['dark-color']};
            justify-content: space-between;
            svg{
                color: #5A5F7D !important;
                cursor: move;
            }
            .status-bullet{
                position: relative;
                bottom: 2px;
                min-width: 7px;
                height: 7px;
                display: inline-block;
                border-radius: 50%;
               ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')} : 8px;
               &.Personal{
                background: #3498db;
               }
               &.Lead{
                background: #e74c3c;
               }
               &.Contact{
                background: #2ecc71;
               }
               &.Account{
                background: #f39c12;
               }
               &.Deal{
                background: #9b59b6;
               }
               &.Task{
                background: #16a085;
               }
               &.Meeting{
                background: #f1c40f;
               }
            }
        }
        p {
            overflow: hidden;
            // white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 100%; // Set the maximum width of the paragraph
          }
        .actions{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 18px;
            .star{
                svg,
                i,
                span{
                    color: ${({ theme }) => theme['gray-color']} !important;
                }
                &.active{
                    svg,
                    i,
                    span{
                        color: ${({ theme }) => theme['warning-color']} !important;
                    } 
                } 
            }
            span{
                display: inline-block;
                margin: -5px;
                a {
                    margin: 5px;
                    svg,
                    i,
                    span{
                        color: ${({ theme }) => theme['gray-color']} !important;
                    }
                }
            }
            .ant-dropdown-trigger{
                svg{
                    color: #868EAE;
                }
            }
        }        
    } 
    &.Personal .ant-card .ant-card-body{
        background: #3498db40;
        &:hover{
            background: #3498db90;
        }
    }
    &.Lead .ant-card .ant-card-body{
        background: #e74c3c40;
        &:hover{
            background: #e74c3c90;
        }
    }
    &.Contact .ant-card .ant-card-body{
        background: #2ecc7140;
        &:hover{
            background: #2ecc7190;
        }
    }
    &.Account .ant-card .ant-card-body{
        background: #f39c1240;
        &:hover{
            background: #f39c1290;
        }
    }  
    &.Deal .ant-card .ant-card-body{
        background: #9b59b640;
        &:hover{
            background: #9b59b690;
        }
    } 
    &.Task .ant-card .ant-card-body{
        background: #16a08540;
        &:hover{
            background: #16a08590;
        }
    } 
    &.Meeting .ant-card .ant-card-body{
        background: #f1c40f40;
        &:hover{
            background: #f1c40f90;
        }
    } 
`;
const Bullet = Styled.span`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 10px;
    &.personal{
        background: #407fe9;
    }
    &.work{
        background: #20C997;
    }
    &.social{
        background: #FA8B0C;
    }
    &.important{
        background: #2C99FF;
    }
`;
export { Card, Bullet };
